import React from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

function PasswordInput({ name, label, value, handleChange, disabled }) {
  return (
    <Input
      autocomplete="new"
      className="input"
      disabled={disabled}
      id={label}
      name={name}
      type="password"
      value={value}
      onChange={handleChange}
    />
  );
}
PasswordInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  disabled: PropTypes.bool,
  handleChange: PropTypes.func
};

PasswordInput.defaultProps = {
  value: ""
};

export default PasswordInput;
